import store from '@/store';
import { CODE_ENV_LIST } from '@/common/constants/ConstCode';
import { nativeShareText } from '@/common/utils/module/NativeRequest';
import { showTextModal } from '@/common/utils/ModalState';
import { getCurrentPath, isIPad, isIPhone } from '@/common/utils/Util';

export const memorialShare = () => {
  const memorial = store.getters['memorial/getDetail']; // 추모관 정보
  let deads = memorial.deadsInfo;

  let deadsForm = `고인 : ${deads.map(dead => dead.deadName).join(', ')}님`;

  const form = `[Life END Life] \n\n${deadsForm}의 온라인 추모관에 귀하를 모십니다. \n링크 : ${
    CODE_ENV_LIST.DYNAMIC_DOMAIN
  }/${getCurrentPath()}`;

  console.log('form', form);

  nativeShareText(form);
  navigator.clipboard.writeText(form).then(() => {
    if (!isIPhone() && !isIPad()) {
      showTextModal('현재 추모관 내용이 복사되었습니다.', '확인');
    }
  });
};

/**
 * 카카오 공유하기
 */
export const memorialKakaoShare = () => {
  const memorial = store.getters['memorial/getDetail']; // 추모관 정보

  let deadsName = memorial.deadsInfo.map(dead => dead.deadName).join(', ');

  Kakao.Share.createDefaultButton({
    container: '#kakaotalk-sharing-btn',
    objectType: 'feed',
    content: {
      title: `${deadsName}님의 추모관`,
      imageUrl: `${CODE_ENV_LIST.FILE_SERVER_URL}/origin/backgroundImage/flower/33.jpg`,
      link: {
        webUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/memorial/wreath/${memorial.memorialNo}`,
        mobileWebUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/memorial/wreath/${memorial.memorialNo}`
      }
    },
    itemContent: {
      profileText: 'Life END Life',
      profileImageUrl: `${CODE_ENV_LIST.FILE_SERVER_URL}/origin/AppIcon.png?v=2`
    },
    buttons: [
      {
        title: '확인하기',
        link: {
          webUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/memorial/wreath/${memorial.memorialNo}`,
          mobileWebUrl: `${CODE_ENV_LIST.DYNAMIC_DOMAIN}/memorial/wreath/${memorial.memorialNo}`
        }
      }
    ]
  });
};
